import { render, staticRenderFns } from "./AgenciasMainList.vue?vue&type=template&id=51e4dbd3&scoped=true&"
import script from "./AgenciasMainList.vue?vue&type=script&lang=js&"
export * from "./AgenciasMainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e4dbd3",
  null
  
)

export default component.exports